import React from 'react';
import { Spinner } from '@etiquette-ui/misc';
import { dateFormat } from 'utils/date';
import Header from './components/Header';
import Table from './components/Table';
import styled from 'styled-components';
import { getData } from './utils/data';
import withGroupingAndBlacklist from './hocs/withGroupingAndBlacklist';

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 420px;
`;

const Hosts = ({ data, blacklist, isWaiting = false }) => {

    return (
        <>
            {!data || !!isWaiting ? (
                <Container>
                    <Spinner style={{ '--size': '120px', '--color': '#364456', '--bg': '#fff' }} />
                </Container>
            ) : (
                <div style={{padding: '40px'}}>
                    {!!data &&
                        data.stats.map((element, i) => {
                            const { title, avgs, items } = getData(element, dateFormat, blacklist);
                            const { title : previousTitle } = !!data.stats[i - 1] ? getData(data.stats[i - 1], dateFormat, blacklist) : {};
                            const day = element.period.day;
                            return (
                                <>
                                    <Header title={previousTitle === title ? undefined : title} avgs={avgs} />
                                    <Table header={data.shifts} items={items} withAttendance={!day} />
                                </>
                            );
                        })}
                </div>
            )}
        </>
    );
};

export default withGroupingAndBlacklist(Hosts);
